import { login, refreshToken } from "@/api/system/permission/login";
import { getToken, setToken, getRefreshToken, setRefreshToken, setExpiresIn, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    refreshToken: getRefreshToken(),
    name: '',
    level: '',
    deptType: '',
    avatar: '',
    roles: [],
    permissions: [],
    user: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_REFRESH_TOKEN: (state, token) => {
      state.refreshToken = token
    },

    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_LEVEL: (state, level) => {
      state.level = level
    },
    SET_DEPTTYPE: (state, deptType) => {
      state.deptType = deptType
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_USER: (state, user) => {
      state.user = user
    }
  },

  actions: {
    // 登录
    Login({ commit }, loginInfo) {
      const loginName = loginInfo.loginName.trim()
      const password = loginInfo.password
      return new Promise((resolve, reject) => {
        login({ loginName, password }).then(res => {
          let data = res.data;
          setToken(data.accessToken)
          commit('SET_TOKEN', data.accessToken)
          // setRefreshToken(data.refreshToken)
          // commit('SET_REFRESH_TOKEN', data.accessToken)
          // setExpiresIn(data.expires_in)
          // commit('SET_EXPIRES_IN', data.expires_in)
          resolve(res)
        }).catch(error => {
          reject(error)
        })


      })
    },



    // 刷新token
    RefreshToken({ commit, state }) {
      let searchInfo = {
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
      };

      return new Promise((resolve, reject) => {
        refreshToken(searchInfo).then(res => {
          setToken(res.data.accessToken)
          commit('SET_TOKEN', res.data.accessToken)
          setRefreshToken(res.data.refreshToken)
          commit('SET_REFRESH_TOKEN', res.accessToken)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      let loginInfo = {
        accessToken: state.token,
        password: userInfo.password,
      };
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_PERMISSIONS', [])
        removeToken()
        resolve()
        // logout(state.token).then(() => {
        //   commit('SET_TOKEN', '')
        //   commit('SET_ROLES', [])
        //   commit('SET_PERMISSIONS', [])
        //   removeToken()
        //   resolve()
        // }).catch(error => {
        //   reject(error)
        // })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
